import React from "react";
import styled from "styled-components";

export const DateMain = styled("div")`
  font-family: "Source Sans Pro",sans-serif;
  display: flex;
  float: right;
  flex-direction: row;
  margin-right: 15px;
`;

export const DateDropDownContainer = styled("div")`
  margin-left: auto;
  margin-right: 0.9rem;
  cursor: pointer;
`;

export const DateDropDownHeader = styled("div")`
  margin-bottom: 0.5em;
  margin-top: 0.5em;
  padding: 0.6em 0.7em 0.5em 0.7em;
  box-shadow: 0 1px 4px 0 grey;
  font-weight: normal;
  font-size: 1.3rem;
  color: #ffffff;
  background: #3eb462;
  border: 0.1rem solid;
  border-radius: 0.6rem;
  white-space: nowrap;
  display: flex;
  flex-direction: row;
`;

export const DateDropDownListContainer = styled("div")`
  position: absolute;
  z-index: 5;
`;

export const DateDropDownList = styled("ul")`
  margin-right: 0.5em;
  padding: 0.5em;
  background: #ffffff;
  border: 2px solid #e5e5e5;
  box-sizing: border-box;
  color: #605f70;
  font-size: 1.4em;
  font-weight: 500;

  &:first-child {
    border: 0.1rem solid grey;
  }
  border-radius: 0.5rem;
`;

export const DateIconContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin-left: 0.8rem;
`;

export const DateListItem = styled("li")`
  display: block;
  padding-top: 0.5em;
  padding-left: 0.5rem;
  list-style: none;
  border-radius: 0.2rem;
  padding-bottom: 0.5em;

  &:hover {
    background-color: #50c878;
  }
`;
